export default __webpack_public_path__ + "openCollapsible.0be026c5.png";